import axios from "axios";

const getTransportQuotationsAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&page=${
        payload.currentPage
      }&countries=[${payload.selectedCountries}]&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&orderColumn=${payload.sort ? payload.sort.column : 0}&search=${
        payload.search ?? ""
      }`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export default getTransportQuotationsAPI;
